import LanguageSelectorMenu from './LanguageSelectorMenu';

export default LanguageSelectorMenu;
